// The MyGaz name as a picture, never typed (Ruben, 2 Nov 2026): a translated
// page split the typed « MyGaz » with spaces. « mygaz » in the splash's type,
// drawn once in the vault (Projects/mygaz/design-system/wordmark); the dark
// version, with « gaz » in white, swaps in with the theme.
export function Wordmark({ white = false }: { white?: boolean }) {
  if (white) return <img className="wm" src="./mygaz-wordmark-white.svg" alt="MyGaz" />;
  return (
    <span className="wm" role="img" aria-label="MyGaz">
      <img className="wm-l" src="./mygaz-wordmark.svg" alt="" />
      <img className="wm-d" src="./mygaz-wordmark-on-dark.svg" alt="" />
    </span>
  );
}
